module.exports = __webpack_public_path__ + "media/images/icons/smp_check_scores-3c2b4b0b59602577eac221de9197bedf.svg";